Auth = require 'db/auth'
ApiAjax = require 'network/api-ajax'
EntityDisplay = require 'lib/entity-display'
FilterState = require 'view-models/notification-filter-state'
{ ldclient } = require 'common/lib/ldclient'
NotificationView = require './notification-view'
NotificationEmptyState = require './notification-empty-state'
React = require 'react'
recup = require 'recup'
trackUe = require 'debug/trackUe'
TFM = require 'lib/markdown/tfm'
_ = require 'underscore'
SimpleTest = require 'lib/experiments/simple-test'
AnimateHeight = require('react-animate-height').default

animatingClasses =
  animating:                  'animating'
  animatingUp:                'animating-up'
  animatingDown:              'animating-down'
  static:                     'static'
  animatingToHeightZero:      'animating-zero'
  animatingToHeightAuto:      'animating-auto'
  staticHeightZero:           'static-zero'
  staticHeightAuto:           'static-auto'

# Update here too:
# stylesheets/components/views/header/notifications.less
animatingTiming = 500

previousMemberID = 0
previousType = ''
module.exports = class extends React.Component
  displayName: 'NotificationsList'

  trackWithData: (verb, dirObj, prepObj, indObj, method, context) ->
    { card, list, board } = context

    context = JSON.stringify
      cardId: card?.id
      listId: list?.id
      boardId: board?.id

    trackUe('header', verb, dirObj, prepObj, indObj, method, context)

  constructor: (props) ->
    super(props)
    { notifications } = @props

    @state = {
      now: new Date()
    }

    allNotifications = @_notificationPropsToState(notifications)

    # Render the first 30 notifications/groups in the initial render
    # When there's a lot of notifications, we don't want the first render to
    # take a long time
    @state.notifications = allNotifications.slice(0, 30)

    @timeout = setTimeout =>
      if @mounted
        @setState notifications: allNotifications
    , 100

  componentDidMount: ->
    @mounted = true
    @interval = setInterval(@updateNow, 10000)

  componentWillUnmount: ->
    @mounted = false
    clearInterval(@interval)

  componentWillReceiveProps: (nextProps) ->
    clearTimeout(@timeout)
    @setState notifications: @_notificationPropsToState(nextProps.notifications)

  updateNow: =>
    @setState now: new Date()

  _notificationPropsToState: (notifications) ->
    _.map(notifications.groupings, (notificationGrouping, key) =>
      props = notificationGrouping
      { archive, active } = _.groupBy notificationGrouping.notifications,
        (n) -> if n.get('unread') then 'active' else 'archive'

      if !active?
        lastDateRead = _.last(archive).get('dateRead')
        if lastDateRead?
          active = _.filter(archive, (n) => n.get('dateRead') == lastDateRead)
        else
          active = _.last(archive, 1)
        archive = _.difference(archive, active)

      props.showArchiveButton = props.unreadCount != props.notifications.length && archive? && archive.length > 0

      props.active = _.map(active, @_generatePropsFromNotif)
      props.archive = _.map(archive, @_generatePropsFromNotif)

      props.toggleRead = =>
        if props.active?
          @toggleStatus props.active
          firstNotification = props.active[0]
          @trackWithData(
            if firstNotification.unread
              'marks as read'
            else
              'marks as unread'
            'notification'
            'on notifications menu'
            ''
            'by clicking toggle button',
            firstNotification
          )

      props.key = key
      return props
    )

  _generatePropsFromNotif: (notif, i = 0) =>
    { now } = @state

    entityDisplay = new EntityDisplay('notificationsGrouped')

    if i == 0
      previousMemberID = 0
      previousType = ''

    notifProps = notif.getExpandedData()
    notifProps.id = notif.get('id')
    notifProps.type = notif.get('type')
    notifProps.iconKey = notif.get('display')?.translationKey
    notifProps.actionLink = notif.getActionLink()
    notifProps.shouldGenerateActionLink = notif.shouldGenerateActionLink()

    notifProps.entities = entityDisplay.getEntities(notif.get 'display')
    for entity in notifProps.entities
      if entity.type == 'comment'
        entity.textHtml = TFM.comments.format(entity.text).output
      else if entity.type == 'relDate'
        entity.text = entityDisplay.relDateText(entity.date, now)

    if notifProps.type == 'cardDueSoon'
      notifProps.isDueDateNotification = true
    else if notifProps.type in [
      'declinedInvitationToBoard'
      'declinedInvitationToOrganization'
    ]
      notifProps.isDeclinedInvitationNotification = true

    if /Enterprise/.test(notifProps.type)
      notifProps.isEnterpriseAdmin = Auth.me().isEnterpriseAdminOf(notif.get('data').enterprise)

    notifProps.isDueSoon = notifProps.type == 'cardDueSoon'
    notifProps.isCommentLike = notif.isCommentLike()
    notifProps.isAddAttachment = notif.isAddAttachment()
    notifProps.idMemberCreator = notif.get('idMemberCreator')
    notifProps.isSystemNotification = notifProps.isDueSoon || notifProps.isDeclinedInvitationNotification

    notifProps.markRead = notif.markRead.bind(notif)
    notifProps.setData = (data) -> notif.set(data)

    notifProps.deletedMember = notif.get('display')?.entities?.memberCreator?.translationKey == "notification_deleted_account"
    member = notif.getMember()

    if notifProps.deletedMember
      member = { id: 'deleted account' }
    if notifProps.isSystemNotification
      member = { id: 'system' }

    if (member? && previousMemberID != member.id)
      notifProps.member = member
      previousMemberID = member.id
    else if (member? && previousType == 'reactionAdded')
      # Notifications for reactions are not grouped by member like other
      # notifications, so we need to attach the member to the next notif
      # after a reactionAdded notification
      notifProps.member = member
    previousType = notifProps.type

    # reactions props
    reactionsInNotifications = SimpleTest('tacoHearts')?.get('enabled') &&
      ldclient.variation('web.reactions_in_notifications', false)

    notifProps.actionId = notif.get('idAction')
    notifProps.reactionList = notif.reactionList
    notifProps.showReactions =
      reactionsInNotifications && notifProps.isCommentLike
    notifProps.canReact = reactionsInNotifications && notif.getBoard()?.canComment(Auth.me()) && notif.getCard()
    notifProps.memberReactorsFullNames = notif.getMemberReactorsFullNames()
    notifProps.idAction = notif.get('idAction')

    notifProps

  toggleStatus: (notifications) =>
    me = Auth.me()
    status = notifications[0].unread
    cacheRead = notifications[0].dateRead
    dateRead = if status then new Date() else null

    me.setNotifications
      notifications: notifications
      data:
        read: status
        ids: _.chain(notifications)
          .map((notif) -> notif.id)
          .join(',')
          .value()
      setFn: (notif) ->
        notif.setData
          dateRead: dateRead
          unread: !status
      errorFn: (notif) ->
        notif.setData
          dateRead: cacheRead
          unread: status

  hasUnreadNotifications: (notifications) ->
    _.some notifications, (notifProps) ->
      notifProps.unread == true

  render: ->
    {
      visibilityFilter,
      visibilityButtonClicked,
      onAnimationStart,
      onAnimationEnd
     } = @props
    { notifications } = @state

    React.createElement 'div', className: 'notification-list',
      React.createElement NotificationEmptyState,
        visible:
          (visibilityFilter ==  FilterState::VISIBILITY_ALL && notifications.length == 0) || \
          (visibilityFilter ==  FilterState::VISIBILITY_UNREAD && !@hasUnreadNotifications(notifications))
        isShowAll: visibilityFilter ==  FilterState::VISIBILITY_ALL
        buttonClicked: visibilityButtonClicked

      notifications.map (notifProps) =>
        height =
          if visibilityFilter ==  FilterState::VISIBILITY_UNREAD && notifProps.unread == false
            0
          else
            'auto'

        React.createElement AnimateHeight, {
          onAnimationStart: onAnimationStart,
          onAnimationEnd: onAnimationEnd,
          duration: animatingTiming
          height: height
          animationStateClasses: animatingClasses
          applyInlineTransitions: false
          key: "animate-#{notifProps.key}"
        }, React.createElement NotificationView, notifProps



// WEBPACK FOOTER //
// ./app/scripts/views/notification/notification-list.coffee